import { render, staticRenderFns } from "./regionPage.vue?vue&type=template&id=03df0522&scoped=true&"
import script from "./regionPage.vue?vue&type=script&lang=js&"
export * from "./regionPage.vue?vue&type=script&lang=js&"
import style0 from "./regionPage.vue?vue&type=style&index=0&id=03df0522&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03df0522",
  null
  
)

export default component.exports